<script setup lang="ts">
import { NavigationLinkTabs } from '@shared/ui/menus'

import { useTaskCreationMenu } from '../../model/creation/task-creation-menu.hook'

defineOptions({
  name: 'TaskCreationMenu',
})

const {
  config,
} = useTaskCreationMenu()
</script>

<template>
  <NavigationLinkTabs
    :config="config"
  />
</template>
